export default "__VITE_ASSET__BcDrEJT3__"